import view from '../Enums';

var extraHeightForHotelRoom = {
  [view.DESKTOP]: 70,
  [view.MOBILE]: 61
};

export var extraHeightForHotelRoom;
